import { toast } from "react-toastify";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { _PerformanceEvaluationPeriod, _single } from "../../../../core/services/dataBean/EntityCatalog";
import useModal, { MODAL_LG, MODAL_md } from "../../../theme/Component/hooks/useModal";
import { useEffect } from "react";
import { ListMenu } from "../../../theme/Component/ListMenu";
import { BasicPage } from "../../../theme/Component/BasicPage";
import { BasicTable } from "../../../theme/Component/BasicTable";
import { Modal } from "../../../theme/Component/Modal";
import { YearSelector } from "../../../../core/shared/inputs/YearSelector";
import { InputDate } from "../../../theme/Input/InputDate";

interface PerfomanceEvaluationProps {
    isModal?: boolean;
    onChange?: Function;
}

export const PerformanceEvaluationPeriod = ({ isModal, onChange }: PerfomanceEvaluationProps) => {

    const { instance, bean, setBean, lista, setLista, addRequiredFields, isMissing, isRequired, validateForm } = useDataBean(_PerformanceEvaluationPeriod);
    // const paginador = usePaginator();

    const modal = useModal("", MODAL_md);
    const modalC = useModal("Eliminar Periodo de Evaluación", MODAL_md);

    useEffect(() => {
        addRequiredFields(["EvaluationYear", "UptoDate", "FromDate"]);
        getLista();
    }, [])

    const getLista = () => {
        const props = {
            State: 1
        }

        instance.getPerformanceEvaluationPeriodCatalogPorPropiedades(props, null).then(
            (resp: any) => {
                // paginador.setPages(resp.NumberOfPages);
                // paginador.setRecords(resp.NumberOfPages * 15);
                setLista(resp);
            }
        ).catch(err => {
            toast.error(err);
        });
    };

    const head = [
        { title: 'ID', property: 'IDPerformanceEvaluationPeriod', visible: true },
        { title: 'Vigencia', property: 'IDJobRequisition', visible: true },
        { title: 'Fecha desde', property: 'FromDate', visible: true },
        { title: 'Fecha hasta', property: 'UptoDate', visible: true },
        { title: 'Usuario que Modifica', property: 'IDEmployee', visible: false },
    ];

    const create = () => {
        setBean({
            State: 1,
            EvaluationYear: _single.getCurrenYear(),
        });
        modal.open("Agregar Periodo de Evaluación");
    }

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: _single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]

    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: _single.canEdit(), evento: () => { modal.open("Editar Periodo de Evaluación"); } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: _single.canDelete(), evento: () => { modalC.open() } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    const deleteItem = () => {
        const data = { ...bean, State: 2 }
        editaItem(data)
    };

    const editaItem = (obj: any) => {
        if (!validateForm()) {
            toast.error("Faltan Campos Obligatorios por diligenciar");
            return;
        }
        instance.updatePerformanceEvaluationPeriod({ ...obj, IDEmployee: _single.getAccountID() }).then(
            (resp: any) => {
                getLista();
                modal.close();
                modalC.close()
            }
        ).catch(err => {
            toast.error(err);
        })
    }

    const setRowBean = (obj: any) => {
        onChange?.(obj);
        setBean(obj);
    }

    const componentRender = () => {
        return (
            <div className="row">
                <div className="col-md-12">
                    <BasicTable listButtons={listaBotones()} body={lista} head={head} rowSet={setRowBean} iconButtons={iconButtonsItem} />

                    <Modal modal={modal.modal} updateModal={modal.setModal} eventModal={() => { editaItem(bean) }}>
                        <div className="row">
                            <div className="col-md-12">
                                <label className={`${isMissing('EvaluationYear') ? 'has-error' : ''}`}>Vigencia {isRequired('EvaluationYear') ? <span className="text-danger">*</span> : ''}</label>
                                <YearSelector tittle=" " value={bean.EvaluationYear} onChange={(e) => { setBean({ ...bean, EvaluationYear: e }) }} />
                            </div>

                            <div className="col-md-12">
                                <label className={`${isMissing('FromDate') ? 'has-error' : ''}`}>Fecha desde {isRequired('FromDate') ? <span className="text-danger">*</span> : ''}</label>
                                <InputDate value={bean.FromDate} setDate={(e) => { setBean({ ...bean, FromDate: e }) }} label="" name="FromDate" />
                            </div>

                            <div className="col-md-12">
                                <label className={`${isMissing('UptoDate') ? 'has-error' : ''}`}>Fecha hasta {isRequired('UptoDate') ? <span className="text-danger">*</span> : ''}</label>
                                <InputDate value={bean.UptoDate} setDate={(e) => { setBean({ ...bean, UptoDate: e }) }} label="" name="UptoDate" />
                            </div>
                        </div>
                    </Modal>

                    <Modal modal={modalC.modal} updateModal={modalC.setModal} eventModal={() => { deleteItem() }} >
                        <div className="row">
                            <div className="col-md-12">
                                <p>Desea eliminar el periodo de evaluación {bean.IDPerformanceEvaluationPeriod}</p>
                            </div>
                        </div>
                    </Modal>
                </div>
            </div>
        )
    }

    return isModal ? componentRender() :
        (
            <BasicPage titulo="Periodos de Evaluaciones">
                {componentRender()}
            </BasicPage>
        )
}